import { create } from 'zustand'
import Property from '../models/Property';
import properties from '../data/properties';


export const usePropertyStore = create(set => ({
    properties: properties,
    setProperties: (properties) => set({ properties }),

    addProperty: (propertyData) => set(state => ({
        properties: [...state.properties, new Property(propertyData)]
    })),

    updateProperty: (id, updatedData) => {
        set(state => {
            const updatedProperties = state.properties.map(property =>
                property.id === id ? { ...property, ...updatedData } : property
            );
            console.log(updatedProperties);
            return {
                properties:updatedProperties
            }
        })
    },

    deleteProperty: (id) => set(state => ({
        properties: state.properties.filter(property => property.id !== id)
    }))
}));